export default function setPageName(company)  {
  document.title = company;
}
